import { QueryClientProvider } from '@tanstack/react-query'
import { QueryClientInstance } from '@apis'
import NiceModal from '@ebay/nice-modal-react'
import { WebInitialized } from '@/provide/WebInitialized'
import { ServiceInitialized } from '@/provide/ServiceInitialized'
import RootLayout from '@/layouts'
import { AlertsManager } from './components/alerts'
import { LoadingManager, ToastSingleManager } from './components/toast'
import { SonnerToaster } from './components/ui/sonner'
import { UnLoginInterceptor } from './provide/UnLoginInterceptor'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const App = () => {
  return (
    <div className="flex h-full w-full flex-col">
      <QueryClientProvider client={QueryClientInstance}>
        <NiceModal.Provider>
          {/*共用的初始化*/}
          <WebInitialized />

          {/*針對服務的初始化*/}
          <ServiceInitialized />

          {/*Global Manager*/}
          <AlertsManager />
          <ToastSingleManager />
          <LoadingManager />
          <SonnerToaster />

          {/* 未登入攔截 (先簡單寫，之後有需要的話再看怎麼改) */}
          <UnLoginInterceptor>
            {/* Layout 樣式 */}
            <RootLayout />
          </UnLoginInterceptor>
        </NiceModal.Provider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  )
}

export default App
